// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsNormalizationParameters_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4H26V18H24V16H20L20 18H23V18.083C20.1623 18.559 18 21.027 18 24H14V26H18V24C18 25.5367 18.5777 26.9385 19.5278 28H0V4ZM20 8H24V10H20V8ZM20 12H24V14H20V12ZM12 24V26H8V24H12ZM6 24V26H2L2 24H6ZM14 22H18V20H14V22ZM12 20V22H8V20H12ZM14 18H18V16H14L14 18ZM12 16L12 18H8V16H12ZM14 14H18V12H14V14ZM12 12V14H8V12H12ZM14 10H18V8H14V10ZM12 8V10H8V8H12ZM2 8V10H6V8H2ZM2 12L2 14H6V12H2ZM2 16V18H6V16H2ZM2 20L2 22H6V20H2Z" class="svg-bg"/>
  <path d="M23.333 27.436C22.8783 27.436 22.4493 27.359 22.046 27.205 21.6427 27.0437 21.287 26.809 20.979 26.501 20.6783 26.193 20.44 25.8117 20.264 25.357 20.088 24.895 20 24.3633 20 23.762 20 23.168 20.0917 22.64 20.275 22.178 20.4583 21.7087 20.704 21.3127 21.012 20.99 21.32 20.6673 21.6793 20.4217 22.09 20.253 22.5007 20.0843 22.9333 20 23.388 20 23.85 20 24.2643 20.0953 24.631 20.286 24.9977 20.4693 25.302 20.6857 25.544 20.935L24.686 21.969C24.5027 21.8003 24.3083 21.6647 24.103 21.562 23.905 21.452 23.6777 21.397 23.421 21.397 23.179 21.397 22.948 21.452 22.728 21.562 22.5153 21.6647 22.3283 21.815 22.167 22.013 22.013 22.211 21.8883 22.453 21.793 22.739 21.705 23.025 21.661 23.3477 21.661 23.707 21.661 24.4477 21.8187 25.0233 22.134 25.434 22.4493 25.8373 22.871 26.039 23.399 26.039 23.6923 26.039 23.9527 25.9767 24.18 25.852 24.4147 25.72 24.62 25.5587 24.796 25.368L25.654 26.38C25.0527 27.084 24.279 27.436 23.333 27.436ZM26.7433 27.304V20.132H28.3603V25.94H31.1983V27.304H26.7433Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsNormalizationParameters is a generated icon component.
 */
let IconRmsNormalizationParameters = IconRmsNormalizationParameters_1 = class IconRmsNormalizationParameters extends IconBaseElement {
    render() {
        return html `${IconRmsNormalizationParameters_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsNormalizationParameters.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconRmsNormalizationParameters = IconRmsNormalizationParameters_1 = __decorate([
    customElement('zui-icon-rms-normalization-parameters')
], IconRmsNormalizationParameters);
export { IconRmsNormalizationParameters };
